const NS = 'resources.invoice.refundDialog';

// Translation keys, keyed by a short name used in the components. The strings live in the
// Lokalise BBO project; components call translate(keys.x, data) and rely on the remote catalog.
export const keys = {
  breadcrumb: `${NS}.breadcrumb`,
  title: `${NS}.title`,
  titleInstant: `${NS}.titleInstant`,
  pspReference: `${NS}.pspReference`,
  close: `${NS}.close`,
  warningTitle: `${NS}.warningTitle`,
  warningBody: `${NS}.warningBody`,
  lineItemsTitle: `${NS}.lineItemsTitle`,
  selected: `${NS}.selected`,
  noteLabel: `${NS}.noteLabel`,
  noteCounter: `${NS}.noteCounter`,
  emptyTitle: `${NS}.emptyTitle`,
  emptyBody: `${NS}.emptyBody`,
  emptyRefundInProgress: `${NS}.emptyRefundInProgress`,
  cancel: `${NS}.cancel`,
  confirm: `${NS}.confirm`,
  confirmWithTotal: `${NS}.confirmWithTotal`,
  discardTitle: `${NS}.discardTitle`,
  discardBody: `${NS}.discardBody`,
  keepEditing: `${NS}.keepEditing`,
  discard: `${NS}.discard`,
  meterRefundable: `${NS}.meterRefundable`,
  meterSelected: `${NS}.meterSelected`,
  meterRemaining: `${NS}.meterRemaining`,
  meterOver: `${NS}.meterOver`,
  meterOverRate: `${NS}.meterOverRate`,
  meterHint: `${NS}.meterHint`,
  clearAll: `${NS}.clearAll`,
  colItem: `${NS}.colItem`,
  colVat: `${NS}.colVat`,
  colOriginal: `${NS}.colOriginal`,
  colOriginalInfo: `${NS}.colOriginalInfo`,
  colRefund: `${NS}.colRefund`,
  overOriginal: `${NS}.overOriginal`,
  tableHelp: `${NS}.tableHelp`,
  amountAria: `${NS}.amountAria`,
  summaryTitle: `${NS}.summaryTitle`,
  enterAmountHint: `${NS}.enterAmountHint`,
  vatBreakdown: `${NS}.vatBreakdown`,
  summaryVatRow: `${NS}.summaryVatRow`,
  multiRateNote: `${NS}.multiRateNote`,
  totalHt: `${NS}.totalHt`,
  totalVat: `${NS}.totalVat`,
  totalToCredit: `${NS}.totalToCredit`,
  confirmTitle: `${NS}.confirmTitle`,
  confirmBody: `${NS}.confirmBody`,
  submittedTitle: `${NS}.submittedTitle`,
  submittedPending: `${NS}.submittedPending`,
  totalSubmitted: `${NS}.totalSubmitted`,
  submittedBreakdownTitle: `${NS}.submittedBreakdownTitle`,
  submittedNext: `${NS}.submittedNext`,
  fieldNote: `${NS}.fieldNote`,
  backToInvoices: `${NS}.backToInvoices`,
  refundNoteTitle: `${NS}.refundNoteTitle`,
  download: `${NS}.download`,
  openInTab: `${NS}.openInTab`,
  loadingPdf: `${NS}.loadingPdf`,
  pdfError: `${NS}.pdfError`,
  segment: type => `${NS}.segment.${type}`,
};

// Turns an unknown segment enum into a readable label (e.g. OVERMILEAGE -> "Overmileage").
const prettify = type =>
  type
    ? type
        .replace(/_/g, ' ')
        .toLowerCase()
        .replace(/^\w/, c => c.toUpperCase())
    : '';

// Localized segment label. react-admin's translate returns the key itself when it is
// missing from the catalog, so a raw fee name (no segment translation) falls back to prettify.
export const segmentLabel = (translate, type) => {
  const key = keys.segment(type);
  const label = translate(key);
  return label === key ? prettify(type) : label;
};

export const MAX_NOTE_LENGTH = 500;

// Upper bound on a per-line refund amount, so an unreasonably long value cannot be typed.
// Over-budget amounts stay reachable on purpose: the budget meter reports them and blocks confirm.
export const MAX_REFUND_AMOUNT = 9999999999;

export const CONTENT_MAX_WIDTH = 1120;
